/**
 * Promo strip on /home for the Refer & Earn → 50/50 loop.
 *
 * Shape matches the eraser-buy banner so an admin toggle (the
 * `home_banner_show_fiftyfifty` feature flag) can swap one for the
 * other without shifting the page. Pink palette — same accent the
 * 50/50 HUD chip + the notifications inbox row use, so the visual
 * language is consistent everywhere the 50/50 concept appears.
 *
 * Links to /invite, the only way to earn 50/50s in this phase
 * (referrals + admin rank rewards).
 */

export function referFiftyfiftyBannerHtml() {
  return `
    <div
      class="card refer-fiftyfifty-banner"
      style="padding:8px 10px;margin-bottom:8px;background:linear-gradient(135deg,#3A1528 0%,#5B2C91 100%);border-color:rgba(233,75,162,0.55);"
    >
      <a href="/invite" data-link class="row"
         style="align-items:center;gap:8px;text-decoration:none;color:inherit;min-width:0;">
        <div style="font-size:18px;line-height:1;color:#FF8FB6;flex-shrink:0;">
          <svg viewBox="0 0 24 24" width="18" height="18"
               aria-hidden="true" style="display:block;">
            <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2.2"/>
            <path d="M12 3a9 9 0 0 0 0 18z" fill="currentColor" stroke="none"/>
            <line x1="12" y1="3" x2="12" y2="21" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="grow" style="min-width:0;">
          <div style="color:#fff;font-weight:700;font-size:12.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            Refer a friend — earn a 50/50
          </div>
          <div style="color:rgba(255,255,255,0.78);font-weight:500;font-size:10.5px;line-height:1.25;margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            They play their first live trivia. You get a power-up.
          </div>
        </div>
        <span
          class="btn sm"
          style="padding:4px 10px;font-size:12px;line-height:1.2;flex-shrink:0;margin:0;background:rgba(233,75,162,0.22);border:1px solid rgba(233,75,162,0.55);color:#fff;font-weight:700;"
        >
          Invite
        </span>
      </a>
    </div>
  `;
}
